let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("edP6u")).then(() => parcelRequire('djWMf'));